<template>
  <div class="wrapper">
    <!-- <div><img src="../assets/images/loginbg.jpg"></div> -->
    <div style="margin: 200px auto; background-color: #fff; width: 350px; height: 350px; padding: 20px; border-radius: 10px">
      <div style="margin: 20px 0; text-align: center; font-size: 24px"><b>可视化平台登录</b></div>
      <el-form :model="user" :rules="rules" ref="userForm">
        <el-form-item prop="name">
          <el-input  size="medium" style="margin: 10px 0" prefix-icon="el-icon-user-solid" v-model="user.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="mediun" style="margin: 10px 0" prefix-icon="el-icon-lock" show-password v-model="user.password"></el-input>
        </el-form-item>
        <div  style="display: flex;">
          <div>
            <router-link to="/backstagelogin" style="line-height:center;">后台管理系统登入</router-link>
          </div>
          <div style="margin-left: auto; text-align: right">
            <el-button type="primary" size="small" autocomplete="off" @click="login">登录</el-button>
            <!-- <el-button type="warning" size="small" autocomplete="off" @click="$router.push('/register')">注册</el-button> -->
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
// import ValidCode from '@/components/ValidCode.vue'
export default {
  name: "login",
  data () {
    return {
      user: {
        name: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }]
      },
      ValidCode:''
    }
  },
  createValidCode:'',
  methods: {
    login () {
      this.$refs["userForm"].validate((valid) => {
        if (valid) {
          this.request.post("/api/user/login",this.user).then(res => {
            if (res.code === "200") {//表单校验合法
              localStorage.setItem("user", JSON.stringify(res.data)) //把res里的数据存在浏览器里
              this.$router.push("/page1")
              this.$message.success("登录成功！")
            } else {
              this.$message.error("用户名或密码错误!")
            }
          })
        }
      })
    },
  },
  created() {
    // 清除用户信息，确保安全
    localStorage.removeItem('user');
    this.user = { name: '', password: '' };
  },
}
</script>

<style scoped>

  .wrapper {
    height: 100%;
    /* background: linear-gradient(to bottom right, #03044A, rgb(94, 7, 116)); */
    background: url('../assets/images/loginbg.jpg');
    overflow: hidden;
  }
</style>